import axios from 'axios';

export const getBanner = async () => {

    const { data } = await axios.get(`${process.env.REACT_APP_AWS_URL}/api/banner/getbanner`);

    return data;

}